"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_TRAITS = void 0;
exports.ALL_TRAITS = [
    {
        id: 2,
        type: 'Background',
        name: 'Blue Diag',
        displayName: 'Blue Diag',
        traitIndex: 2,
        tokenCount: 245,
    },
    {
        id: 3,
        type: 'Background',
        name: 'Blue Orange Diag',
        displayName: 'Blue Orange Diag',
        traitIndex: 3,
        tokenCount: 207,
    },
    {
        id: 4,
        type: 'Background',
        name: 'Blue Solid',
        displayName: 'Blue Solid',
        traitIndex: 4,
        tokenCount: 353,
    },
    {
        id: 5,
        type: 'Background',
        name: 'Candy Stripe',
        displayName: 'Candy Stripe',
        traitIndex: 5,
        tokenCount: 145,
    },
    {
        id: 6,
        type: 'Background',
        name: 'Codelines',
        displayName: 'Codelines',
        traitIndex: 6,
        tokenCount: 29,
    },
    {
        id: 7,
        type: 'Background',
        name: 'Dark Purple Solid',
        displayName: 'Dark Purple Solid',
        traitIndex: 7,
        tokenCount: 356,
    },
    {
        id: 8,
        type: 'Background',
        name: 'Double Green',
        displayName: 'Double Green',
        traitIndex: 8,
        tokenCount: 310,
    },
    {
        id: 9,
        type: 'Background',
        name: 'Double Pink',
        displayName: 'Double Pink',
        traitIndex: 9,
        tokenCount: 301,
    },
    {
        id: 10,
        type: 'Background',
        name: 'Double Purple',
        displayName: 'Double Purple',
        traitIndex: 10,
        tokenCount: 342,
    },
    {
        id: 11,
        type: 'Background',
        name: 'Double Yellow',
        displayName: 'Double Yellow',
        traitIndex: 11,
        tokenCount: 344,
    },
    {
        id: 12,
        type: 'Background',
        name: 'Green Black Diag',
        displayName: 'Green Black Diag',
        traitIndex: 12,
        tokenCount: 234,
    },
    {
        id: 13,
        type: 'Background',
        name: 'Green Blue Vert',
        displayName: 'Green Blue Vert',
        traitIndex: 13,
        tokenCount: 189,
    },
    {
        id: 14,
        type: 'Background',
        name: 'Green Diag',
        displayName: 'Green Diag',
        traitIndex: 14,
        tokenCount: 257,
    },
    {
        id: 15,
        type: 'Background',
        name: 'Green Double Stripe',
        displayName: 'Green Double Stripe',
        traitIndex: 15,
        tokenCount: 185,
    },
    {
        id: 16,
        type: 'Background',
        name: 'Green Solid',
        displayName: 'Green Solid',
        traitIndex: 16,
        tokenCount: 374,
    },
    {
        id: 17,
        type: 'Background',
        name: 'Green Stripe',
        displayName: 'Green Stripe',
        traitIndex: 17,
        tokenCount: 165,
    },
    {
        id: 19,
        type: 'Background',
        name: 'Grey Solid',
        displayName: 'Grey Solid',
        traitIndex: 19,
        tokenCount: 335,
    },
    {
        id: 20,
        type: 'Background',
        name: 'Light Blue Solid',
        displayName: 'Light Blue Solid',
        traitIndex: 20,
        tokenCount: 352,
    },
    {
        id: 21,
        type: 'Background',
        name: 'Magenta Solid',
        displayName: 'Magenta Solid',
        traitIndex: 21,
        tokenCount: 365,
    },
    {
        id: 23,
        type: 'Background',
        name: 'Metropolis 2',
        displayName: 'Metropolis 2',
        traitIndex: 23,
        tokenCount: 35,
    },
    {
        id: 24,
        type: 'Background',
        name: 'Orange Solid',
        displayName: 'Orange Solid',
        traitIndex: 24,
        tokenCount: 321,
    },
    {
        id: 25,
        type: 'Background',
        name: 'Orange Tie Dye',
        displayName: 'Orange Tie Dye',
        traitIndex: 25,
        tokenCount: 47,
    },
    {
        id: 26,
        type: 'Background',
        name: 'Peach Blue Vert',
        displayName: 'Peach Blue Vert',
        traitIndex: 26,
        tokenCount: 161,
    },
    {
        id: 27,
        type: 'Background',
        name: 'Peach Solid',
        displayName: 'Peach Solid',
        traitIndex: 27,
        tokenCount: 357,
    },
    {
        id: 28,
        type: 'Background',
        name: 'Pink Diag',
        displayName: 'Pink Diag',
        traitIndex: 28,
        tokenCount: 207,
    },
    {
        id: 29,
        type: 'Background',
        name: 'Pink Solid',
        displayName: 'Pink Solid',
        traitIndex: 29,
        tokenCount: 383,
    },
    {
        id: 30,
        type: 'Background',
        name: 'Purple Green Diag',
        displayName: 'Purple Green Diag',
        traitIndex: 30,
        tokenCount: 209,
    },
    {
        id: 31,
        type: 'Background',
        name: 'Purple Orange Diag',
        displayName: 'Purple Orange Diag',
        traitIndex: 31,
        tokenCount: 247,
    },
    {
        id: 32,
        type: 'Background',
        name: 'Purple Solid',
        displayName: 'Purple Solid',
        traitIndex: 32,
        tokenCount: 348,
    },
    {
        id: 34,
        type: 'Background',
        name: 'Purple Tie Dye',
        displayName: 'Purple Tie Dye',
        traitIndex: 34,
        tokenCount: 54,
    },
    {
        id: 35,
        type: 'Background',
        name: 'Red Solid',
        displayName: 'Red Solid',
        traitIndex: 35,
        tokenCount: 363,
    },
    {
        id: 36,
        type: 'Background',
        name: 'Sun',
        displayName: 'Sun',
        traitIndex: 36,
        tokenCount: 18,
    },
    {
        id: 37,
        type: 'Background',
        name: 'Triple Blue',
        displayName: 'Triple Blue',
        traitIndex: 37,
        tokenCount: 205,
    },
    {
        id: 38,
        type: 'Background',
        name: 'Triple Green',
        displayName: 'Triple Green',
        traitIndex: 38,
        tokenCount: 226,
    },
    {
        id: 39,
        type: 'Background',
        name: 'Triple Pink',
        displayName: 'Triple Pink',
        traitIndex: 39,
        tokenCount: 221,
    },
    {
        id: 40,
        type: 'Background',
        name: 'Yellow Diag',
        displayName: 'Yellow Diag',
        traitIndex: 40,
        tokenCount: 239,
    },
    {
        id: 41,
        type: 'Background',
        name: 'Yellow Double Stripe',
        displayName: 'Yellow Double Stripe',
        traitIndex: 41,
        tokenCount: 212,
    },
    {
        id: 42,
        type: 'Background',
        name: 'Yellow Pink Diag',
        displayName: 'Yellow Pink Diag',
        traitIndex: 42,
        tokenCount: 215,
    },
    {
        id: 44,
        type: 'Race',
        name: 'Alien',
        displayName: 'Alien',
        traitIndex: 0,
        tokenCount: 874,
    },
    {
        id: 45,
        type: 'Race',
        name: 'Bot',
        displayName: 'Bot',
        traitIndex: 1,
        tokenCount: 1312,
    },
    {
        id: 46,
        type: 'Race',
        name: 'Human 1',
        displayName: 'Human',
        traitIndex: 2,
        tokenCount: 766,
    },
    {
        id: 47,
        type: 'Race',
        name: 'Human 10',
        displayName: 'Human',
        traitIndex: 3,
        tokenCount: 726,
    },
    {
        id: 49,
        type: 'Race',
        name: 'Human 3',
        displayName: 'Human',
        traitIndex: 5,
        tokenCount: 784,
    },
    {
        id: 50,
        type: 'Race',
        name: 'Human 4',
        displayName: 'Human',
        traitIndex: 6,
        tokenCount: 765,
    },
    {
        id: 51,
        type: 'Race',
        name: 'Human 5',
        displayName: 'Human',
        traitIndex: 7,
        tokenCount: 811,
    },
    {
        id: 52,
        type: 'Race',
        name: 'Human 6',
        displayName: 'Human',
        traitIndex: 8,
        tokenCount: 747,
    },
    {
        id: 53,
        type: 'Race',
        name: 'Human 7',
        displayName: 'Human',
        traitIndex: 9,
        tokenCount: 792,
    },
    {
        id: 54,
        type: 'Race',
        name: 'Human 8',
        displayName: 'Human',
        traitIndex: 10,
        tokenCount: 788,
    },
    {
        id: 55,
        type: 'Race',
        name: 'Human 9',
        displayName: 'Human',
        traitIndex: 11,
        tokenCount: 757,
    },
    {
        id: 56,
        type: 'Race',
        name: 'Skull Blue',
        displayName: 'Skull Blue',
        traitIndex: 12,
        tokenCount: 16,
    },
    {
        id: 57,
        type: 'Race',
        name: 'Skull Gold',
        displayName: 'Skull Gold',
        traitIndex: 13,
        tokenCount: 8,
    },
    {
        id: 58,
        type: 'Race',
        name: 'Skull',
        displayName: 'Skull',
        traitIndex: 14,
        tokenCount: 45,
    },
    {
        id: 1,
        type: 'Background',
        name: 'Black Orange Diag',
        displayName: 'Black Orange Diag',
        traitIndex: 1,
        tokenCount: 211,
    },
    {
        id: 22,
        type: 'Background',
        name: 'Metropolis 1',
        displayName: 'Metropolis 1',
        traitIndex: 22,
        tokenCount: 33,
    },
    {
        id: 33,
        type: 'Background',
        name: 'Purple Stripe',
        displayName: 'Purple Stripe',
        traitIndex: 33,
        tokenCount: 177,
    },
    {
        id: 43,
        type: 'Background',
        name: 'Yellow Solid',
        displayName: 'Yellow Solid',
        traitIndex: 43,
        tokenCount: 354,
    },
    {
        id: 48,
        type: 'Race',
        name: 'Human 2',
        displayName: 'Human',
        traitIndex: 4,
        tokenCount: 809,
    },
    {
        id: 164,
        type: 'Eyes',
        name: 'Draag Alien',
        displayName: 'Draag Alien',
        traitIndex: 16,
        tokenCount: 277,
    },
    {
        id: 63,
        type: 'Mouth',
        name: 'Lipstick Blue',
        displayName: 'Lipstick Blue',
        traitIndex: 4,
        tokenCount: 618,
    },
    {
        id: 64,
        type: 'Mouth',
        name: 'Lipstick Green',
        displayName: 'Lipstick Green',
        traitIndex: 5,
        tokenCount: 635,
    },
    {
        id: 65,
        type: 'Mouth',
        name: 'Lipstick Purple',
        displayName: 'Lipstick Purple',
        traitIndex: 6,
        tokenCount: 648,
    },
    {
        id: 66,
        type: 'Mouth',
        name: 'Lipstick Red',
        displayName: 'Lipstick Red',
        traitIndex: 7,
        tokenCount: 930,
    },
    {
        id: 67,
        type: 'Mouth',
        name: 'Missing Tooth',
        displayName: 'Missing Tooth',
        traitIndex: 8,
        tokenCount: 315,
    },
    {
        id: 76,
        type: 'Face',
        name: 'Beard Brown',
        displayName: 'Beard Brown',
        traitIndex: 3,
        tokenCount: 247,
    },
    {
        id: 61,
        type: 'Mouth',
        name: 'Idle',
        displayName: 'Idle',
        traitIndex: 2,
        tokenCount: 1280,
    },
    {
        id: 70,
        type: 'Mouth',
        name: 'Smile',
        displayName: 'Smile',
        traitIndex: 11,
        tokenCount: 1018,
    },
    {
        id: 75,
        type: 'Face',
        name: 'Beard Black',
        displayName: 'Beard Black',
        traitIndex: 2,
        tokenCount: 241,
    },
    {
        id: 72,
        type: 'Mouth',
        name: 'Teethy Grin',
        displayName: 'Teethy Grin',
        traitIndex: 13,
        tokenCount: 938,
    },
    {
        id: 73,
        type: 'Face',
        name: 'Basic Mustache Black',
        displayName: 'Basic Mustache Black',
        traitIndex: 0,
        tokenCount: 269,
    },
    {
        id: 74,
        type: 'Face',
        name: 'Basic Mustache Brwn',
        displayName: 'Basic Mustache Brwn',
        traitIndex: 1,
        tokenCount: 207,
    },
    {
        id: 83,
        type: 'Face',
        name: 'Fu Manchu Mustache Black',
        displayName: 'Fu Manchu Mustache Black',
        traitIndex: 10,
        tokenCount: 140,
    },
    {
        id: 80,
        type: 'Face',
        name: 'Bot Missing Face',
        displayName: 'Bot Missing Face',
        traitIndex: 7,
        tokenCount: 0,
    },
    {
        id: 84,
        type: 'Face',
        name: 'Fu Manchu Mustache Brown',
        displayName: 'Fu Manchu Mustache Brown',
        traitIndex: 11,
        tokenCount: 150,
    },
    {
        id: 93,
        type: 'Face',
        name: 'Rough Mustache Black',
        displayName: 'Rough Mustache Black',
        traitIndex: 20,
        tokenCount: 248,
    },
    {
        id: 78,
        type: 'Face',
        name: 'Blu Manchu Mustache',
        displayName: 'Blu Manchu Mustache',
        traitIndex: 5,
        tokenCount: 19,
    },
    {
        id: 81,
        type: 'Face',
        name: 'Clown Facepaint',
        displayName: 'Clown Facepaint',
        traitIndex: 8,
        tokenCount: 121,
    },
    {
        id: 87,
        type: 'Face',
        name: 'Jet Black',
        displayName: 'Jet Black',
        traitIndex: 14,
        tokenCount: 125,
    },
    {
        id: 92,
        type: 'Face',
        name: 'Mutton Chop Winged Mustache Brown',
        displayName: 'Mutton Chop Winged Mustache Brown',
        traitIndex: 19,
        tokenCount: 274,
    },
    {
        id: 101,
        type: 'Face',
        name: 'Thin Curled Mustache Black',
        displayName: 'Thin Curled Mustache Black',
        traitIndex: 28,
        tokenCount: 255,
    },
    {
        id: 86,
        type: 'Face',
        name: 'Goatee Black',
        displayName: 'Goatee Black',
        traitIndex: 13,
        tokenCount: 242,
    },
    {
        id: 89,
        type: 'Face',
        name: 'Mutton Chop Curled Mustache Black',
        displayName: 'Mutton Chop Curled Mustache Black',
        traitIndex: 16,
        tokenCount: 248,
    },
    {
        id: 90,
        type: 'Face',
        name: 'Mutton Chop Curled Mustache Brown',
        displayName: 'Mutton Chop Curled Mustache Brown',
        traitIndex: 17,
        tokenCount: 246,
    },
    {
        id: 91,
        type: 'Face',
        name: 'Mutton Chop Winged Mustache Black',
        displayName: 'Mutton Chop Winged Mustache Black',
        traitIndex: 18,
        tokenCount: 269,
    },
    {
        id: 97,
        type: 'Face',
        name: 'Soul Patch Long',
        displayName: 'Soul Patch Long',
        traitIndex: 24,
        tokenCount: 263,
    },
    {
        id: 100,
        type: 'Face',
        name: 'Thick Curled Mustache Brown',
        displayName: 'Thick Curled Mustache Brown',
        traitIndex: 27,
        tokenCount: 221,
    },
    {
        id: 98,
        type: 'Face',
        name: 'Soul Patch Short',
        displayName: 'Soul Patch Short',
        traitIndex: 25,
        tokenCount: 267,
    },
    {
        id: 99,
        type: 'Face',
        name: 'Thick Curled Mustache Black',
        displayName: 'Thick Curled Mustache Black',
        traitIndex: 26,
        tokenCount: 254,
    },
    {
        id: 106,
        type: 'FaceAccessory',
        name: 'Ninja',
        displayName: 'Ninja',
        traitIndex: 1,
        tokenCount: 81,
    },
    {
        id: 108,
        type: 'FaceAccessory',
        name: 'Oni Mask Purple',
        displayName: 'Oni Mask Purple',
        traitIndex: 3,
        tokenCount: 96,
    },
    {
        id: 125,
        type: 'EarAccessory',
        name: 'Open Face Shield',
        displayName: 'Open Face Shield',
        traitIndex: 6,
        tokenCount: 169,
    },
    {
        id: 104,
        type: 'Face',
        name: 'Winged Mustache Brown',
        displayName: 'Winged Mustache Brown',
        traitIndex: 31,
        tokenCount: 265,
    },
    {
        id: 107,
        type: 'FaceAccessory',
        name: 'Oni Mask Green',
        displayName: 'Oni Mask Green',
        traitIndex: 2,
        tokenCount: 77,
    },
    {
        id: 110,
        type: 'FaceAccessory',
        name: 'Oxygen mask',
        displayName: 'Oxygen mask',
        traitIndex: 5,
        tokenCount: 242,
    },
    {
        id: 111,
        type: 'FaceAccessory',
        name: 'Viral Mask',
        displayName: 'Viral Mask',
        traitIndex: 6,
        tokenCount: 403,
    },
    {
        id: 113,
        type: 'Mask',
        name: 'Gas Tank Mask',
        displayName: 'Gas Tank Mask',
        traitIndex: 1,
        tokenCount: 213,
    },
    {
        id: 114,
        type: 'Mask',
        name: 'Hockey Mask',
        displayName: 'Hockey Mask',
        traitIndex: 2,
        tokenCount: 86,
    },
    {
        id: 118,
        type: 'Mask',
        name: 'Squid Mask',
        displayName: 'Squid Mask',
        traitIndex: 6,
        tokenCount: 34,
    },
    {
        id: 119,
        type: 'EarAccessory',
        name: 'Candy Raver Earrings',
        displayName: 'Candy Raver Earrings',
        traitIndex: 0,
        tokenCount: 926,
    },
    {
        id: 120,
        type: 'EarAccessory',
        name: 'Chain Earring',
        displayName: 'Chain Earring',
        traitIndex: 1,
        tokenCount: 565,
    },
    {
        id: 121,
        type: 'EarAccessory',
        name: 'Earpiece',
        displayName: 'Earpiece',
        traitIndex: 2,
        tokenCount: 194,
    },
    {
        id: 122,
        type: 'EarAccessory',
        name: 'Gold Stud Cross Combo',
        displayName: 'Gold Stud Cross Combo',
        traitIndex: 3,
        tokenCount: 586,
    },
    {
        id: 116,
        type: 'Mask',
        name: 'Polygon Mask',
        displayName: 'Polygon Mask',
        traitIndex: 4,
        tokenCount: 13,
    },
    {
        id: 117,
        type: 'Mask',
        name: 'Robo-Jaw',
        displayName: 'Robo-Jaw',
        traitIndex: 5,
        tokenCount: 24,
    },
    {
        id: 123,
        type: 'EarAccessory',
        name: 'Gold Stud Earrings',
        displayName: 'Gold Stud Earrings',
        traitIndex: 4,
        tokenCount: 934,
    },
    {
        id: 129,
        type: 'MouthAccessory',
        name: 'Blunt',
        displayName: 'Blunt',
        traitIndex: 0,
        tokenCount: 836,
    },
    {
        id: 130,
        type: 'MouthAccessory',
        name: 'Cig',
        displayName: 'Cig',
        traitIndex: 1,
        tokenCount: 2415,
    },
    {
        id: 127,
        type: 'EarAccessory',
        name: 'Silver Stud Earrings',
        displayName: 'Silver Stud Earrings',
        traitIndex: 8,
        tokenCount: 1306,
    },
    {
        id: 128,
        type: 'EarAccessory',
        name: 'Small Hoop Earrings',
        displayName: 'Small Hoop Earrings',
        traitIndex: 9,
        tokenCount: 1240,
    },
    {
        id: 131,
        type: 'MouthAccessory',
        name: 'Cigar',
        displayName: 'Cigar',
        traitIndex: 2,
        tokenCount: 545,
    },
    {
        id: 134,
        type: 'MouthAccessory',
        name: 'Pipe',
        displayName: 'Pipe',
        traitIndex: 5,
        tokenCount: 276,
    },
    {
        id: 140,
        type: 'Nose',
        name: 'Delicate',
        displayName: 'Delicate',
        traitIndex: 3,
        tokenCount: 1053,
    },
    {
        id: 141,
        type: 'Nose',
        name: 'Downturned',
        displayName: 'Downturned',
        traitIndex: 4,
        tokenCount: 1105,
    },
    {
        id: 144,
        type: 'Nose',
        name: 'Prominent Stud Piercing',
        displayName: 'Prominent Stud Piercing',
        traitIndex: 7,
        tokenCount: 1058,
    },
    {
        id: 145,
        type: 'Nose',
        name: 'Prominent',
        displayName: 'Prominent',
        traitIndex: 8,
        tokenCount: 1088,
    },
    {
        id: 162,
        type: 'Eyes',
        name: 'Draag Alien Variant 1',
        displayName: 'Draag Alien Variant 1',
        traitIndex: 14,
        tokenCount: 126,
    },
    {
        id: 137,
        type: 'Nose',
        name: 'Bot Nose 1',
        displayName: 'Bot Nose 1',
        traitIndex: 0,
        tokenCount: 325,
    },
    {
        id: 139,
        type: 'Nose',
        name: 'Bot Nose 3',
        displayName: 'Bot Nose 3',
        traitIndex: 2,
        tokenCount: 340,
    },
    {
        id: 142,
        type: 'Nose',
        name: 'Droopy Stud Piercing',
        displayName: 'Droopy Stud Piercing',
        traitIndex: 5,
        tokenCount: 1129,
    },
    {
        id: 143,
        type: 'Nose',
        name: 'Droopy',
        displayName: 'Droopy',
        traitIndex: 6,
        tokenCount: 1053,
    },
    {
        id: 151,
        type: 'Eyes',
        name: 'Beady Variant 4',
        displayName: 'Beady Variant 4',
        traitIndex: 3,
        tokenCount: 121,
    },
    {
        id: 152,
        type: 'Eyes',
        name: 'Beady Variant 5',
        displayName: 'Beady Variant 5',
        traitIndex: 4,
        tokenCount: 96,
    },
    {
        id: 163,
        type: 'Eyes',
        name: 'Draag Alien Variant 2',
        displayName: 'Draag Alien Variant 2',
        traitIndex: 15,
        tokenCount: 94,
    },
    {
        id: 147,
        type: 'Nose',
        name: 'Upturned',
        displayName: 'Upturned',
        traitIndex: 10,
        tokenCount: 1056,
    },
    {
        id: 149,
        type: 'Eyes',
        name: 'Beady Variant 2',
        displayName: 'Beady Variant 2',
        traitIndex: 1,
        tokenCount: 93,
    },
    {
        id: 155,
        type: 'Eyes',
        name: 'Bot Beady Wide',
        displayName: 'Bot Beady Wide',
        traitIndex: 7,
        tokenCount: 66,
    },
    {
        id: 160,
        type: 'Eyes',
        name: 'Closed Variant 2',
        displayName: 'Closed Variant 2',
        traitIndex: 12,
        tokenCount: 88,
    },
    {
        id: 161,
        type: 'Eyes',
        name: 'Closed',
        displayName: 'Closed',
        traitIndex: 13,
        tokenCount: 286,
    },
    {
        id: 154,
        type: 'Eyes',
        name: 'Beady',
        displayName: 'Beady',
        traitIndex: 6,
        tokenCount: 283,
    },
    {
        id: 157,
        type: 'Eyes',
        name: 'Bot Busted Eye',
        displayName: 'Bot Busted Eye',
        traitIndex: 9,
        tokenCount: 75,
    },
    {
        id: 158,
        type: 'Eyes',
        name: 'Bot Idle',
        displayName: 'Bot Idle',
        traitIndex: 10,
        tokenCount: 97,
    },
    {
        id: 159,
        type: 'Eyes',
        name: 'Closed Variant 1',
        displayName: 'Closed Variant 1',
        traitIndex: 11,
        tokenCount: 116,
    },
    {
        id: 169,
        type: 'Eyes',
        name: 'Femme Furrowed Variant 5',
        displayName: 'Femme Furrowed Variant 5',
        traitIndex: 21,
        tokenCount: 85,
    },
    {
        id: 171,
        type: 'Eyes',
        name: 'Femme Idle Variant 1',
        displayName: 'Femme Idle Variant 1',
        traitIndex: 23,
        tokenCount: 98,
    },
    {
        id: 172,
        type: 'Eyes',
        name: 'Femme Idle Variant 2',
        displayName: 'Femme Idle Variant 2',
        traitIndex: 24,
        tokenCount: 113,
    },
    {
        id: 174,
        type: 'Eyes',
        name: 'Femme Idle Variant 4',
        displayName: 'Femme Idle Variant 4',
        traitIndex: 26,
        tokenCount: 98,
    },
    {
        id: 193,
        type: 'Eyes',
        name: 'Masc Furrowed Variant 4',
        displayName: 'Masc Furrowed Variant 4',
        traitIndex: 45,
        tokenCount: 123,
    },
    {
        id: 194,
        type: 'Eyes',
        name: 'Masc Furrowed',
        displayName: 'Masc Furrowed',
        traitIndex: 46,
        tokenCount: 236,
    },
    {
        id: 221,
        type: 'Eyes',
        name: 'Villian Eyes',
        displayName: 'Villian Eyes',
        traitIndex: 73,
        tokenCount: 268,
    },
    {
        id: 166,
        type: 'Eyes',
        name: 'Femme Furrowed Variant 2',
        displayName: 'Femme Furrowed Variant 2',
        traitIndex: 18,
        tokenCount: 101,
    },
    {
        id: 167,
        type: 'Eyes',
        name: 'Femme Furrowed Variant 3',
        displayName: 'Femme Furrowed Variant 3',
        traitIndex: 19,
        tokenCount: 109,
    },
    {
        id: 168,
        type: 'Eyes',
        name: 'Femme Furrowed Variant 4',
        displayName: 'Femme Furrowed Variant 4',
        traitIndex: 20,
        tokenCount: 101,
    },
    {
        id: 173,
        type: 'Eyes',
        name: 'Femme Idle Variant 3',
        displayName: 'Femme Idle Variant 3',
        traitIndex: 25,
        tokenCount: 84,
    },
    {
        id: 178,
        type: 'Eyes',
        name: 'Femme Shade Eyes Variant 3',
        displayName: 'Femme Shade Eyes Variant 3',
        traitIndex: 30,
        tokenCount: 112,
    },
    {
        id: 179,
        type: 'Eyes',
        name: 'Femme Shade Eyes',
        displayName: 'Femme Shade Eyes',
        traitIndex: 31,
        tokenCount: 179,
    },
    {
        id: 180,
        type: 'Eyes',
        name: 'Femme Star Liner',
        displayName: 'Femme Star Liner',
        traitIndex: 32,
        tokenCount: 278,
    },
    {
        id: 181,
        type: 'Eyes',
        name: 'Femme Wide Variant 1',
        displayName: 'Femme Wide Variant 1',
        traitIndex: 33,
        tokenCount: 86,
    },
    {
        id: 183,
        type: 'Eyes',
        name: 'Femme Wide Variant 3',
        displayName: 'Femme Wide Variant 3',
        traitIndex: 35,
        tokenCount: 115,
    },
    {
        id: 184,
        type: 'Eyes',
        name: 'Femme Wide',
        displayName: 'Femme Wide',
        traitIndex: 36,
        tokenCount: 276,
    },
    {
        id: 203,
        type: 'Eyes',
        name: 'Masc Shade Eyes Variant 4',
        displayName: 'Masc Shade Eyes Variant 4',
        traitIndex: 55,
        tokenCount: 90,
    },
    {
        id: 176,
        type: 'Eyes',
        name: 'Femme Shade Eyes Variant 1',
        displayName: 'Femme Shade Eyes Variant 1',
        traitIndex: 28,
        tokenCount: 104,
    },
    {
        id: 177,
        type: 'Eyes',
        name: 'Femme Shade Eyes Variant 2',
        displayName: 'Femme Shade Eyes Variant 2',
        traitIndex: 29,
        tokenCount: 71,
    },
    {
        id: 182,
        type: 'Eyes',
        name: 'Femme Wide Variant 2',
        displayName: 'Femme Wide Variant 2',
        traitIndex: 34,
        tokenCount: 98,
    },
    {
        id: 190,
        type: 'Eyes',
        name: 'Masc Furrowed Variant 1',
        displayName: 'Masc Furrowed Variant 1',
        traitIndex: 42,
        tokenCount: 94,
    },
    {
        id: 191,
        type: 'Eyes',
        name: 'Masc Furrowed Variant 2',
        displayName: 'Masc Furrowed Variant 2',
        traitIndex: 43,
        tokenCount: 102,
    },
    {
        id: 192,
        type: 'Eyes',
        name: 'Masc Furrowed Variant 3',
        displayName: 'Masc Furrowed Variant 3',
        traitIndex: 44,
        tokenCount: 113,
    },
    {
        id: 186,
        type: 'Eyes',
        name: 'Look Right Variant 2',
        displayName: 'Look Right Variant 2',
        traitIndex: 38,
        tokenCount: 90,
    },
    {
        id: 188,
        type: 'Eyes',
        name: 'Look Right Variant 4',
        displayName: 'Look Right Variant 4',
        traitIndex: 40,
        tokenCount: 101,
    },
    {
        id: 189,
        type: 'Eyes',
        name: 'Look Right',
        displayName: 'Look Right',
        traitIndex: 41,
        tokenCount: 283,
    },
    {
        id: 200,
        type: 'Eyes',
        name: 'Masc Shade Eyes Variant 1',
        displayName: 'Masc Shade Eyes Variant 1',
        traitIndex: 52,
        tokenCount: 100,
    },
    {
        id: 201,
        type: 'Eyes',
        name: 'Masc Shade Eyes Variant 2',
        displayName: 'Masc Shade Eyes Variant 2',
        traitIndex: 53,
        tokenCount: 110,
    },
    {
        id: 202,
        type: 'Eyes',
        name: 'Masc Shade Eyes Variant 3',
        displayName: 'Masc Shade Eyes Variant 3',
        traitIndex: 54,
        tokenCount: 103,
    },
    {
        id: 196,
        type: 'Eyes',
        name: 'Masc Idle Variant 2',
        displayName: 'Masc Idle Variant 2',
        traitIndex: 48,
        tokenCount: 108,
    },
    {
        id: 198,
        type: 'Eyes',
        name: 'Masc Idle Variant 4',
        displayName: 'Masc Idle Variant 4',
        traitIndex: 50,
        tokenCount: 104,
    },
    {
        id: 199,
        type: 'Eyes',
        name: 'Masc Idle',
        displayName: 'Masc Idle',
        traitIndex: 51,
        tokenCount: 284,
    },
    {
        id: 208,
        type: 'Eyes',
        name: 'Masc Wide Variant 4',
        displayName: 'Masc Wide Variant 4',
        traitIndex: 60,
        tokenCount: 108,
    },
    {
        id: 219,
        type: 'Eyes',
        name: 'Villian Eyes Variant 1',
        displayName: 'Villian Eyes Variant 1',
        traitIndex: 71,
        tokenCount: 107,
    },
    {
        id: 206,
        type: 'Eyes',
        name: 'Masc Wide Variant 2',
        displayName: 'Masc Wide Variant 2',
        traitIndex: 58,
        tokenCount: 109,
    },
    {
        id: 207,
        type: 'Eyes',
        name: 'Masc Wide Variant 3',
        displayName: 'Masc Wide Variant 3',
        traitIndex: 59,
        tokenCount: 96,
    },
    {
        id: 220,
        type: 'Eyes',
        name: 'Villian Eyes Variant 2',
        displayName: 'Villian Eyes Variant 2',
        traitIndex: 72,
        tokenCount: 114,
    },
    {
        id: 217,
        type: 'Eyes',
        name: 'Uninterested Variant 2',
        displayName: 'Uninterested Variant 2',
        traitIndex: 69,
        tokenCount: 110,
    },
    {
        id: 210,
        type: 'Eyes',
        name: 'Robo-Eyes Variant 1',
        displayName: 'Robo-Eyes Variant 1',
        traitIndex: 62,
        tokenCount: 113,
    },
    {
        id: 211,
        type: 'Eyes',
        name: 'Robo-Eyes Variant 2',
        displayName: 'Robo-Eyes Variant 2',
        traitIndex: 63,
        tokenCount: 133,
    },
    {
        id: 212,
        type: 'Eyes',
        name: 'Robo-Eyes',
        displayName: 'Robo-Eyes',
        traitIndex: 64,
        tokenCount: 222,
    },
    {
        id: 213,
        type: 'Eyes',
        name: 'Skull Glowing Blue',
        displayName: 'Skull Glowing Blue',
        traitIndex: 65,
        tokenCount: 4,
    },
    {
        id: 214,
        type: 'Eyes',
        name: 'Skull Red Dot',
        displayName: 'Skull Red Dot',
        traitIndex: 66,
        tokenCount: 54,
    },
    {
        id: 215,
        type: 'Eyes',
        name: 'Skull Yellow Dot',
        displayName: 'Skull Yellow Dot',
        traitIndex: 67,
        tokenCount: 11,
    },
    {
        id: 216,
        type: 'Eyes',
        name: 'Uninterested Variant 1',
        displayName: 'Uninterested Variant 1',
        traitIndex: 68,
        tokenCount: 112,
    },
    {
        id: 226,
        type: 'EyeAccessory',
        name: 'Chainspace Deck Elite III',
        displayName: 'Chainspace Deck Elite III',
        traitIndex: 4,
        tokenCount: 29,
    },
    {
        id: 224,
        type: 'EyeAccessory',
        name: 'Chainspace Deck Elite I',
        displayName: 'Chainspace Deck Elite I',
        traitIndex: 2,
        tokenCount: 107,
    },
    {
        id: 227,
        type: 'EyeAccessory',
        name: 'Chainspace Deck Pro',
        displayName: 'Chainspace Deck Pro',
        traitIndex: 5,
        tokenCount: 163,
    },
    {
        id: 231,
        type: 'EyeAccessory',
        name: 'Eye Patch Monocle',
        displayName: 'Eye Patch Monocle',
        traitIndex: 9,
        tokenCount: 209,
    },
    {
        id: 232,
        type: 'EyeAccessory',
        name: 'Eye Patch Sight',
        displayName: 'Eye Patch Sight',
        traitIndex: 10,
        tokenCount: 148,
    },
    {
        id: 233,
        type: 'EyeAccessory',
        name: 'Eye Patch',
        displayName: 'Eye Patch',
        traitIndex: 11,
        tokenCount: 249,
    },
    {
        id: 234,
        type: 'EyeAccessory',
        name: 'Geordi Visor',
        displayName: 'Geordi Visor',
        traitIndex: 12,
        tokenCount: 60,
    },
    {
        id: 235,
        type: 'EyeAccessory',
        name: 'Glass Visor',
        displayName: 'Glass Visor',
        traitIndex: 13,
        tokenCount: 311,
    },
    {
        id: 236,
        type: 'EyeAccessory',
        name: 'Glasses',
        displayName: 'Glasses',
        traitIndex: 14,
        tokenCount: 247,
    },
    {
        id: 237,
        type: 'EyeAccessory',
        name: 'Goggles',
        displayName: 'Goggles',
        traitIndex: 15,
        tokenCount: 186,
    },
    {
        id: 238,
        type: 'EyeAccessory',
        name: 'Hunter Eyes',
        displayName: 'Hunter Eyes',
        traitIndex: 16,
        tokenCount: 57,
    },
    {
        id: 239,
        type: 'EyeAccessory',
        name: 'Kaneda Goggles',
        displayName: 'Kaneda Goggles',
        traitIndex: 17,
        tokenCount: 150,
    },
    {
        id: 230,
        type: 'EyeAccessory',
        name: 'Deal With It',
        displayName: 'Deal With It',
        traitIndex: 8,
        tokenCount: 55,
    },
    {
        id: 243,
        type: 'EyeAccessory',
        name: 'Nouns',
        displayName: 'Nouns',
        traitIndex: 21,
        tokenCount: 8,
    },
    {
        id: 245,
        type: 'EyeAccessory',
        name: 'Rodman Wrap Arounds',
        displayName: 'Rodman Wrap Arounds',
        traitIndex: 23,
        tokenCount: 44,
    },
    {
        id: 246,
        type: 'EyeAccessory',
        name: 'Scouter Green',
        displayName: 'Scouter Green',
        traitIndex: 24,
        tokenCount: 183,
    },
    {
        id: 247,
        type: 'EyeAccessory',
        name: 'Scouter Red ',
        displayName: 'Scouter Red ',
        traitIndex: 25,
        tokenCount: 198,
    },
    {
        id: 249,
        type: 'EyeAccessory',
        name: 'Sniper Goggles',
        displayName: 'Sniper Goggles',
        traitIndex: 27,
        tokenCount: 154,
    },
    {
        id: 250,
        type: 'EyeAccessory',
        name: 'Sun Glasses Red',
        displayName: 'Sun Glasses Red',
        traitIndex: 28,
        tokenCount: 216,
    },
    {
        id: 241,
        type: 'EyeAccessory',
        name: 'Mad-Eye Monocle',
        displayName: 'Mad-Eye Monocle',
        traitIndex: 19,
        tokenCount: 51,
    },
    {
        id: 242,
        type: 'EyeAccessory',
        name: 'Night Vision Goggles',
        displayName: 'Night Vision Goggles',
        traitIndex: 20,
        tokenCount: 92,
    },
    {
        id: 248,
        type: 'EyeAccessory',
        name: 'Single Eye Reader',
        displayName: 'Single Eye Reader',
        traitIndex: 26,
        tokenCount: 106,
    },
    {
        id: 257,
        type: 'HeadAbove',
        name: 'Beanie Hair Blonde',
        displayName: 'Beanie Hair Blonde',
        traitIndex: 3,
        tokenCount: 133,
    },
    {
        id: 258,
        type: 'HeadAbove',
        name: 'Beanie Hair Green',
        displayName: 'Beanie Hair Green',
        traitIndex: 4,
        tokenCount: 116,
    },
    {
        id: 252,
        type: 'EyeAccessory',
        name: 'Target Visor',
        displayName: 'Target Visor',
        traitIndex: 30,
        tokenCount: 235,
    },
    {
        id: 253,
        type: 'EyeAccessory',
        name: 'Thin Glasses',
        displayName: 'Thin Glasses',
        traitIndex: 31,
        tokenCount: 264,
    },
    {
        id: 255,
        type: 'HeadAbove',
        name: 'Backwards Hat 1',
        displayName: 'Backwards Hat 1',
        traitIndex: 1,
        tokenCount: 148,
    },
    {
        id: 261,
        type: 'HeadAbove',
        name: 'Chain Hat',
        displayName: 'Chain Hat',
        traitIndex: 7,
        tokenCount: 154,
    },
    {
        id: 260,
        type: 'HeadAbove',
        name: 'Blitmap Hat',
        displayName: 'Blitmap Hat',
        traitIndex: 6,
        tokenCount: 105,
    },
    {
        id: 262,
        type: 'HeadAbove',
        name: 'Chain Headband',
        displayName: 'Chain Headband',
        traitIndex: 8,
        tokenCount: 140,
    },
    {
        id: 264,
        type: 'HeadAbove',
        name: 'Cowboy Hat Brown',
        displayName: 'Cowboy Hat Brown',
        traitIndex: 10,
        tokenCount: 116,
    },
    {
        id: 267,
        type: 'HeadAbove',
        name: 'Crown Bald',
        displayName: 'Crown Bald',
        traitIndex: 13,
        tokenCount: 150,
    },
    {
        id: 336,
        type: 'HeadBelow',
        name: 'Widows Peak Blue Hair',
        displayName: 'Widows Peak Blue Hair',
        traitIndex: 34,
        tokenCount: 165,
    },
    {
        id: 268,
        type: 'HeadAbove',
        name: 'Crown Long Hair Blue',
        displayName: 'Crown Long Hair Blue',
        traitIndex: 14,
        tokenCount: 55,
    },
    {
        id: 269,
        type: 'HeadAbove',
        name: 'Crown Long Hair Grey',
        displayName: 'Crown Long Hair Grey',
        traitIndex: 15,
        tokenCount: 58,
    },
    {
        id: 270,
        type: 'HeadAbove',
        name: 'Divine Robe',
        displayName: 'Divine Robe',
        traitIndex: 16,
        tokenCount: 12,
    },
    {
        id: 271,
        type: 'HeadAbove',
        name: 'Dreadlocks',
        displayName: 'Dreadlocks',
        traitIndex: 17,
        tokenCount: 142,
    },
    {
        id: 272,
        type: 'HeadAbove',
        name: 'Dual Horn',
        displayName: 'Dual Horn',
        traitIndex: 18,
        tokenCount: 139,
    },
    {
        id: 277,
        type: 'HeadAbove',
        name: 'Genesis Hat',
        displayName: 'Genesis Hat',
        traitIndex: 23,
        tokenCount: 56,
    },
    {
        id: 278,
        type: 'HeadAbove',
        name: 'Goggles Forehead',
        displayName: 'Goggles Forehead',
        traitIndex: 24,
        tokenCount: 147,
    },
    {
        id: 281,
        type: 'HeadAbove',
        name: 'Half Buzz Half Long Blue Hair',
        displayName: 'Half Buzz Half Long Blue Hair',
        traitIndex: 27,
        tokenCount: 134,
    },
    {
        id: 275,
        type: 'HeadAbove',
        name: 'Flux Hair',
        displayName: 'Flux Hair',
        traitIndex: 21,
        tokenCount: 17,
    },
    {
        id: 276,
        type: 'HeadAbove',
        name: 'Funky Bandana Bald',
        displayName: 'Funky Bandana Bald',
        traitIndex: 22,
        tokenCount: 126,
    },
    {
        id: 303,
        type: 'HeadBelow',
        name: 'Bleached Vertical Spikes',
        displayName: 'Bleached Vertical Spikes',
        traitIndex: 1,
        tokenCount: 163,
    },
    {
        id: 283,
        type: 'HeadAbove',
        name: 'Hood',
        displayName: 'Hood',
        traitIndex: 29,
        tokenCount: 136,
    },
    {
        id: 284,
        type: 'HeadAbove',
        name: 'Horns',
        displayName: 'Horns',
        traitIndex: 30,
        tokenCount: 124,
    },
    {
        id: 285,
        type: 'HeadAbove',
        name: 'Leather Bandana Bald',
        displayName: 'Leather Bandana Bald',
        traitIndex: 31,
        tokenCount: 119,
    },
    {
        id: 287,
        type: 'HeadAbove',
        name: 'Long Pink Pigtails',
        displayName: 'Long Pink Pigtails',
        traitIndex: 33,
        tokenCount: 166,
    },
    {
        id: 294,
        type: 'HeadAbove',
        name: 'Skull Skulletor Hood',
        displayName: 'Skull Skulletor Hood',
        traitIndex: 40,
        tokenCount: 3,
    },
    {
        id: 304,
        type: 'HeadBelow',
        name: 'Blue Vertical Spikes',
        displayName: 'Blue Vertical Spikes',
        traitIndex: 2,
        tokenCount: 178,
    },
    {
        id: 289,
        type: 'HeadAbove',
        name: 'Metal Rice Hat',
        displayName: 'Metal Rice Hat',
        traitIndex: 35,
        tokenCount: 10,
    },
    {
        id: 290,
        type: 'HeadAbove',
        name: 'Mystic Top Hat',
        displayName: 'Mystic Top Hat',
        traitIndex: 36,
        tokenCount: 76,
    },
    {
        id: 291,
        type: 'HeadAbove',
        name: 'Neon Green Industrial Dreads',
        displayName: 'Neon Green Industrial Dreads',
        traitIndex: 37,
        tokenCount: 74,
    },
    {
        id: 292,
        type: 'HeadAbove',
        name: 'Pyramid Hat',
        displayName: 'Pyramid Hat',
        traitIndex: 38,
        tokenCount: 64,
    },
    {
        id: 293,
        type: 'HeadAbove',
        name: 'Silly Copter Hat',
        displayName: 'Silly Copter Hat',
        traitIndex: 39,
        tokenCount: 71,
    },
    {
        id: 302,
        type: 'HeadBelow',
        name: 'Bald Unkempt',
        displayName: 'Bald Unkempt',
        traitIndex: 0,
        tokenCount: 172,
    },
    {
        id: 297,
        type: 'HeadAbove',
        name: 'Straw Hat',
        displayName: 'Straw Hat',
        traitIndex: 43,
        tokenCount: 47,
    },
    {
        id: 298,
        type: 'HeadAbove',
        name: 'Techno Horns',
        displayName: 'Techno Horns',
        traitIndex: 44,
        tokenCount: 44,
    },
    {
        id: 299,
        type: 'HeadAbove',
        name: 'Tie-Dye Bandana Bald',
        displayName: 'Tie-Dye Bandana Bald',
        traitIndex: 45,
        tokenCount: 122,
    },
    {
        id: 308,
        type: 'HeadBelow',
        name: 'Cornrows Green Hair',
        displayName: 'Cornrows Green Hair',
        traitIndex: 6,
        tokenCount: 17,
    },
    {
        id: 311,
        type: 'HeadBelow',
        name: 'Double Pigtail Hair Brown',
        displayName: 'Double Pigtail Hair Brown',
        traitIndex: 9,
        tokenCount: 165,
    },
    {
        id: 337,
        type: 'HeadBelow',
        name: 'Widows Peak Hair',
        displayName: 'Widows Peak Hair',
        traitIndex: 35,
        tokenCount: 191,
    },
    {
        id: 306,
        type: 'HeadBelow',
        name: 'Cornrows Dark Hair',
        displayName: 'Cornrows Dark Hair',
        traitIndex: 4,
        tokenCount: 161,
    },
    {
        id: 309,
        type: 'HeadBelow',
        name: 'Cornrows Light Hair',
        displayName: 'Cornrows Light Hair',
        traitIndex: 7,
        tokenCount: 158,
    },
    {
        id: 310,
        type: 'HeadBelow',
        name: 'Cropped Cut Dark',
        displayName: 'Cropped Cut Dark',
        traitIndex: 8,
        tokenCount: 206,
    },
    {
        id: 60,
        type: 'Mouth',
        name: 'Frown',
        displayName: 'Frown',
        traitIndex: 1,
        tokenCount: 0,
    },
    {
        id: 314,
        type: 'HeadBelow',
        name: 'Face Chain',
        displayName: 'Face Chain',
        traitIndex: 12,
        tokenCount: 82,
    },
    {
        id: 315,
        type: 'HeadBelow',
        name: 'Grey Ceaser',
        displayName: 'Grey Ceaser',
        traitIndex: 13,
        tokenCount: 96,
    },
    {
        id: 316,
        type: 'HeadBelow',
        name: 'Meditation Circlet',
        displayName: 'Meditation Circlet',
        traitIndex: 14,
        tokenCount: 53,
    },
    {
        id: 322,
        type: 'HeadBelow',
        name: 'Mohawk Hair Neon Pink',
        displayName: 'Mohawk Hair Neon Pink',
        traitIndex: 20,
        tokenCount: 171,
    },
    {
        id: 323,
        type: 'HeadBelow',
        name: 'Mohawk Hair',
        displayName: 'Mohawk Hair',
        traitIndex: 21,
        tokenCount: 182,
    },
    {
        id: 324,
        type: 'HeadBelow',
        name: 'Pompadour',
        displayName: 'Pompadour',
        traitIndex: 22,
        tokenCount: 129,
    },
    {
        id: 325,
        type: 'HeadBelow',
        name: 'Punker Spike Neon Green',
        displayName: 'Punker Spike Neon Green',
        traitIndex: 23,
        tokenCount: 130,
    },
    {
        id: 326,
        type: 'HeadBelow',
        name: 'Punker Spike Neon Pink',
        displayName: 'Punker Spike Neon Pink',
        traitIndex: 24,
        tokenCount: 122,
    },
    {
        id: 327,
        type: 'HeadBelow',
        name: 'Purple Fro Hawk',
        displayName: 'Purple Fro Hawk',
        traitIndex: 25,
        tokenCount: 133,
    },
    {
        id: 335,
        type: 'HeadBelow',
        name: 'Well Combed Hair Brwn',
        displayName: 'Well Combed Hair Brwn',
        traitIndex: 33,
        tokenCount: 154,
    },
    {
        id: 320,
        type: 'HeadBelow',
        name: 'Metal Skullcap',
        displayName: 'Metal Skullcap',
        traitIndex: 18,
        tokenCount: 144,
    },
    {
        id: 321,
        type: 'HeadBelow',
        name: 'Mohawk Hair Neon Blue',
        displayName: 'Mohawk Hair Neon Blue',
        traitIndex: 19,
        tokenCount: 172,
    },
    {
        id: 330,
        type: 'HeadBelow',
        name: 'Ruby Rhod Hair',
        displayName: 'Ruby Rhod Hair',
        traitIndex: 28,
        tokenCount: 18,
    },
    {
        id: 331,
        type: 'HeadBelow',
        name: 'Slicked Blonde Hair',
        displayName: 'Slicked Blonde Hair',
        traitIndex: 29,
        tokenCount: 180,
    },
    {
        id: 332,
        type: 'HeadBelow',
        name: 'Slicked Dark Hair',
        displayName: 'Slicked Dark Hair',
        traitIndex: 30,
        tokenCount: 169,
    },
    {
        id: 333,
        type: 'HeadBelow',
        name: 'Sushi Chef Bandana ',
        displayName: 'Sushi Chef Bandana ',
        traitIndex: 31,
        tokenCount: 73,
    },
    {
        id: 334,
        type: 'HeadBelow',
        name: 'Well Combed Hair Blk',
        displayName: 'Well Combed Hair Blk',
        traitIndex: 32,
        tokenCount: 178,
    },
    {
        id: 0,
        type: 'Background',
        name: 'Beam',
        displayName: 'Beam',
        traitIndex: 0,
        tokenCount: 29,
    },
    {
        id: 18,
        type: 'Background',
        name: 'Green Tie Dye',
        displayName: 'Green Tie Dye',
        traitIndex: 18,
        tokenCount: 40,
    },
    {
        id: 59,
        type: 'Mouth',
        name: 'Buck Teeth',
        displayName: 'Buck Teeth',
        traitIndex: 0,
        tokenCount: 663,
    },
    {
        id: 329,
        type: 'HeadBelow',
        name: 'Rough Punk Hair Pink',
        displayName: 'Rough Punk Hair Pink',
        traitIndex: 27,
        tokenCount: 91,
    },
    {
        id: 79,
        type: 'Face',
        name: 'Bot Missing Face w Teeth',
        displayName: 'Bot Missing Face w Teeth',
        traitIndex: 6,
        tokenCount: 0,
    },
    {
        id: 71,
        type: 'Mouth',
        name: 'Teeth Smile',
        displayName: 'Teeth Smile',
        traitIndex: 12,
        tokenCount: 970,
    },
    {
        id: 77,
        type: 'Face',
        name: 'Beard Neon Green',
        displayName: 'Beard Neon Green',
        traitIndex: 4,
        tokenCount: 123,
    },
    {
        id: 85,
        type: 'Face',
        name: 'Furies Facepaint',
        displayName: 'Furies Facepaint',
        traitIndex: 12,
        tokenCount: 32,
    },
    {
        id: 225,
        type: 'EyeAccessory',
        name: 'Chainspace Deck Elite II',
        displayName: 'Chainspace Deck Elite II',
        traitIndex: 3,
        tokenCount: 56,
    },
    {
        id: 94,
        type: 'Face',
        name: 'Rough Mustache Brwn',
        displayName: 'Rough Mustache Brwn',
        traitIndex: 21,
        tokenCount: 236,
    },
    {
        id: 102,
        type: 'Face',
        name: 'Thin Curled Mustache Brown',
        displayName: 'Thin Curled Mustache Brown',
        traitIndex: 29,
        tokenCount: 266,
    },
    {
        id: 103,
        type: 'Face',
        name: 'Winged Mustache Black',
        displayName: 'Winged Mustache Black',
        traitIndex: 30,
        tokenCount: 268,
    },
    {
        id: 105,
        type: 'FaceAccessory',
        name: 'Gas Mask',
        displayName: 'Gas Mask',
        traitIndex: 0,
        tokenCount: 88,
    },
    {
        id: 109,
        type: 'FaceAccessory',
        name: 'Oni Mask Red',
        displayName: 'Oni Mask Red',
        traitIndex: 4,
        tokenCount: 73,
    },
    {
        id: 115,
        type: 'Mask',
        name: "Jack-O'-Lantern",
        displayName: "Jack-O'-Lantern",
        traitIndex: 3,
        tokenCount: 16,
    },
    {
        id: 124,
        type: 'EarAccessory',
        name: 'Large Hoop Earrings',
        displayName: 'Large Hoop Earrings',
        traitIndex: 5,
        tokenCount: 942,
    },
    {
        id: 126,
        type: 'EarAccessory',
        name: 'Silver Stud Cross Combo',
        displayName: 'Silver Stud Cross Combo',
        traitIndex: 7,
        tokenCount: 1268,
    },
    {
        id: 132,
        type: 'MouthAccessory',
        name: 'Dom Rose',
        displayName: 'Dom Rose',
        traitIndex: 3,
        tokenCount: 9,
    },
    {
        id: 229,
        type: 'EyeAccessory',
        name: 'Cybernetic Implants',
        displayName: 'Cybernetic Implants',
        traitIndex: 7,
        tokenCount: 278,
    },
    {
        id: 240,
        type: 'EyeAccessory',
        name: 'Lennon Glasses',
        displayName: 'Lennon Glasses',
        traitIndex: 18,
        tokenCount: 213,
    },
    {
        id: 136,
        type: 'MouthAccessory',
        name: 'Tongue Pill',
        displayName: 'Tongue Pill',
        traitIndex: 7,
        tokenCount: 141,
    },
    {
        id: 146,
        type: 'Nose',
        name: 'Upturned Septum Piercing',
        displayName: 'Upturned Septum Piercing',
        traitIndex: 9,
        tokenCount: 1407,
    },
    {
        id: 148,
        type: 'Eyes',
        name: 'Beady Variant 1',
        displayName: 'Beady Variant 1',
        traitIndex: 0,
        tokenCount: 96,
    },
    {
        id: 153,
        type: 'Eyes',
        name: 'Beady Variant 6',
        displayName: 'Beady Variant 6',
        traitIndex: 5,
        tokenCount: 116,
    },
    {
        id: 165,
        type: 'Eyes',
        name: 'Femme Furrowed Variant 1',
        displayName: 'Femme Furrowed Variant 1',
        traitIndex: 17,
        tokenCount: 104,
    },
    {
        id: 170,
        type: 'Eyes',
        name: 'Femme Furrowed',
        displayName: 'Femme Furrowed',
        traitIndex: 22,
        tokenCount: 299,
    },
    {
        id: 175,
        type: 'Eyes',
        name: 'Femme Idle',
        displayName: 'Femme Idle',
        traitIndex: 27,
        tokenCount: 256,
    },
    {
        id: 195,
        type: 'Eyes',
        name: 'Masc Idle Variant 1',
        displayName: 'Masc Idle Variant 1',
        traitIndex: 47,
        tokenCount: 126,
    },
    {
        id: 197,
        type: 'Eyes',
        name: 'Masc Idle Variant 3',
        displayName: 'Masc Idle Variant 3',
        traitIndex: 49,
        tokenCount: 118,
    },
    {
        id: 204,
        type: 'Eyes',
        name: 'Masc Shade Eyes',
        displayName: 'Masc Shade Eyes',
        traitIndex: 56,
        tokenCount: 284,
    },
    {
        id: 244,
        type: 'EyeAccessory',
        name: 'Robo-Cyclopian',
        displayName: 'Robo-Cyclopian',
        traitIndex: 22,
        tokenCount: 103,
    },
    {
        id: 251,
        type: 'EyeAccessory',
        name: 'Sun Glasses',
        displayName: 'Sun Glasses',
        traitIndex: 29,
        tokenCount: 274,
    },
    {
        id: 209,
        type: 'Eyes',
        name: 'Masc Wide',
        displayName: 'Masc Wide',
        traitIndex: 61,
        tokenCount: 294,
    },
    {
        id: 222,
        type: 'EyeAccessory',
        name: 'Aviators',
        displayName: 'Aviators',
        traitIndex: 0,
        tokenCount: 161,
    },
    {
        id: 223,
        type: 'EyeAccessory',
        name: 'Chainspace Deck Basic',
        displayName: 'Chainspace Deck Basic',
        traitIndex: 1,
        tokenCount: 205,
    },
    {
        id: 96,
        type: 'Face',
        name: 'Soul Patch Long Neon Blue',
        displayName: 'Soul Patch Long Neon Blue',
        traitIndex: 23,
        tokenCount: 116,
    },
    {
        id: 256,
        type: 'HeadAbove',
        name: 'Backwards Hat 2',
        displayName: 'Backwards Hat 2',
        traitIndex: 2,
        tokenCount: 132,
    },
    {
        id: 259,
        type: 'HeadAbove',
        name: 'Beanie',
        displayName: 'Beanie',
        traitIndex: 5,
        tokenCount: 91,
    },
    {
        id: 265,
        type: 'HeadAbove',
        name: 'Cowboy Hat Pink',
        displayName: 'Cowboy Hat Pink',
        traitIndex: 11,
        tokenCount: 37,
    },
    {
        id: 280,
        type: 'HeadAbove',
        name: 'Green Short Hair',
        displayName: 'Green Short Hair',
        traitIndex: 26,
        tokenCount: 150,
    },
    {
        id: 282,
        type: 'HeadAbove',
        name: 'Half Buzz Half Long Hair',
        displayName: 'Half Buzz Half Long Hair',
        traitIndex: 28,
        tokenCount: 141,
    },
    {
        id: 288,
        type: 'HeadAbove',
        name: 'Long Styled Hair',
        displayName: 'Long Styled Hair',
        traitIndex: 34,
        tokenCount: 125,
    },
    {
        id: 296,
        type: 'HeadAbove',
        name: 'Straight Long Purple Hair',
        displayName: 'Straight Long Purple Hair',
        traitIndex: 42,
        tokenCount: 101,
    },
    {
        id: 301,
        type: 'HeadAbove',
        name: 'Zorg Hair',
        displayName: 'Zorg Hair',
        traitIndex: 47,
        tokenCount: 17,
    },
    {
        id: 307,
        type: 'HeadBelow',
        name: 'Cornrows Dark Topknot Hair',
        displayName: 'Cornrows Dark Topknot Hair',
        traitIndex: 5,
        tokenCount: 193,
    },
    {
        id: 69,
        type: 'Mouth',
        name: 'Smile Double Monroe Piercing',
        displayName: 'Smile Double Monroe Piercing',
        traitIndex: 10,
        tokenCount: 601,
    },
    {
        id: 82,
        type: 'Face',
        name: 'Forehead X Tattoo',
        displayName: 'Forehead X Tattoo',
        traitIndex: 9,
        tokenCount: 143,
    },
    {
        id: 319,
        type: 'HeadBelow',
        name: 'Messy Hair Light',
        displayName: 'Messy Hair Light',
        traitIndex: 17,
        tokenCount: 118,
    },
    {
        id: 135,
        type: 'MouthAccessory',
        name: 'Tongue Out',
        displayName: 'Tongue Out',
        traitIndex: 6,
        tokenCount: 516,
    },
    {
        id: 150,
        type: 'Eyes',
        name: 'Beady Variant 3',
        displayName: 'Beady Variant 3',
        traitIndex: 2,
        tokenCount: 121,
    },
    {
        id: 228,
        type: 'EyeAccessory',
        name: 'Chainspace Deck SE',
        displayName: 'Chainspace Deck SE',
        traitIndex: 6,
        tokenCount: 59,
    },
    {
        id: 266,
        type: 'HeadAbove',
        name: 'Cowboy Hat White',
        displayName: 'Cowboy Hat White',
        traitIndex: 12,
        tokenCount: 108,
    },
    {
        id: 273,
        type: 'HeadAbove',
        name: 'E-Girl Hair',
        displayName: 'E-Girl Hair',
        traitIndex: 19,
        tokenCount: 140,
    },
    {
        id: 279,
        type: 'HeadAbove',
        name: 'Good Morning Bandana Top Knot',
        displayName: 'Good Morning Bandana Top Knot',
        traitIndex: 25,
        tokenCount: 156,
    },
    {
        id: 300,
        type: 'HeadAbove',
        name: 'Trunks Hair',
        displayName: 'Trunks Hair',
        traitIndex: 46,
        tokenCount: 46,
    },
    {
        id: 313,
        type: 'HeadBelow',
        name: 'Double Spike',
        displayName: 'Double Spike',
        traitIndex: 11,
        tokenCount: 98,
    },
    {
        id: 318,
        type: 'HeadBelow',
        name: 'Messy Hair Dark',
        displayName: 'Messy Hair Dark',
        traitIndex: 16,
        tokenCount: 122,
    },
    {
        id: 62,
        type: 'Mouth',
        name: 'Lipstick Black',
        displayName: 'Lipstick Black',
        traitIndex: 3,
        tokenCount: 321,
    },
    {
        id: 68,
        type: 'Mouth',
        name: 'Open Teeth',
        displayName: 'Open Teeth',
        traitIndex: 9,
        tokenCount: 994,
    },
    {
        id: 88,
        type: 'Face',
        name: 'Joker Facepaint',
        displayName: 'Joker Facepaint',
        traitIndex: 15,
        tokenCount: 20,
    },
    {
        id: 95,
        type: 'Face',
        name: 'Skeleton Facepaint',
        displayName: 'Skeleton Facepaint',
        traitIndex: 22,
        tokenCount: 31,
    },
    {
        id: 112,
        type: 'Mask',
        name: 'Full Head Bandage',
        displayName: 'Full Head Bandage',
        traitIndex: 0,
        tokenCount: 187,
    },
    {
        id: 133,
        type: 'MouthAccessory',
        name: 'Joint',
        displayName: 'Joint',
        traitIndex: 4,
        tokenCount: 831,
    },
    {
        id: 138,
        type: 'Nose',
        name: 'Bot Nose 2',
        displayName: 'Bot Nose 2',
        traitIndex: 1,
        tokenCount: 317,
    },
    {
        id: 156,
        type: 'Eyes',
        name: 'Bot Beady',
        displayName: 'Bot Beady',
        traitIndex: 8,
        tokenCount: 83,
    },
    {
        id: 185,
        type: 'Eyes',
        name: 'Look Right Variant 1',
        displayName: 'Look Right Variant 1',
        traitIndex: 37,
        tokenCount: 100,
    },
    {
        id: 187,
        type: 'Eyes',
        name: 'Look Right Variant 3',
        displayName: 'Look Right Variant 3',
        traitIndex: 39,
        tokenCount: 95,
    },
    {
        id: 205,
        type: 'Eyes',
        name: 'Masc Wide Variant 1',
        displayName: 'Masc Wide Variant 1',
        traitIndex: 57,
        tokenCount: 100,
    },
    {
        id: 218,
        type: 'Eyes',
        name: 'Uninterested',
        displayName: 'Uninterested',
        traitIndex: 70,
        tokenCount: 280,
    },
    {
        id: 254,
        type: 'HeadAbove',
        name: 'Alien Hat',
        displayName: 'Alien Hat',
        traitIndex: 0,
        tokenCount: 71,
    },
    {
        id: 263,
        type: 'HeadAbove',
        name: 'Classic Top Hat',
        displayName: 'Classic Top Hat',
        traitIndex: 9,
        tokenCount: 105,
    },
    {
        id: 274,
        type: 'HeadAbove',
        name: 'Eye Hat',
        displayName: 'Eye Hat',
        traitIndex: 20,
        tokenCount: 135,
    },
    {
        id: 286,
        type: 'HeadAbove',
        name: 'Long Green Front Braid',
        displayName: 'Long Green Front Braid',
        traitIndex: 32,
        tokenCount: 132,
    },
    {
        id: 295,
        type: 'HeadAbove',
        name: 'Straight Long Hair',
        displayName: 'Straight Long Hair',
        traitIndex: 41,
        tokenCount: 128,
    },
    {
        id: 305,
        type: 'HeadBelow',
        name: 'Bob Hair',
        displayName: 'Bob Hair',
        traitIndex: 3,
        tokenCount: 187,
    },
    {
        id: 312,
        type: 'HeadBelow',
        name: 'Double Pigtail Hair Pink',
        displayName: 'Double Pigtail Hair Pink',
        traitIndex: 10,
        tokenCount: 197,
    },
    {
        id: 317,
        type: 'HeadBelow',
        name: 'Messy Bun',
        displayName: 'Messy Bun',
        traitIndex: 15,
        tokenCount: 119,
    },
    {
        id: 328,
        type: 'HeadBelow',
        name: 'Rough Punk Hair Black',
        displayName: 'Rough Punk Hair Black',
        traitIndex: 26,
        tokenCount: 121,
    },
];
//# sourceMappingURL=traits.js.map